import ObjectUtil from '@leverege/object-util'
import ArrayUtil from '@leverege/array-util'

import { getTagsForAttributes } from '@leverege/api-attributes'
import BlueprintActions from '~/actions/BlueprintActions.js'
import AttributeTree from './AttributeTree.js'

const initialState = {
  status : 'no blueprint',
  data : null,
  attributeTree : null
};

function project( state = initialState, action ) {

  switch ( action.type ) {

    case BlueprintActions.GET_BLUEPRINT:
      const tree = AttributeTree.attributesToTree( action.blueprint.attributes );
      return { status : null, 
               data : action.blueprint, 
               attributeTree : tree,
               currentTags : getTagsForAttributes( action.blueprint.attributes ) 
      };

    case BlueprintActions.UPDATE_BLUEPRINT: {
      if ( state.data && state.data.id == action.blueprint.id ) {
        return { ...state, data : action.blueprint }
      }
      return state;
    }

    case BlueprintActions.ADD_ATTRIBUTE: {

      const copy = ObjectUtil.copy( state.data );
      if ( !Array.isArray( copy.attributes ) ) {
        copy.attributes = []
      }
      copy.attributes.push( action.attribute );
      const tree = AttributeTree.attributesToTree( copy.attributes );
      return { status : null, 
               data : copy, 
               attributeTree : tree,
               currentTags : getTagsForAttributes( copy.attributes ) 
      };
    }

    case BlueprintActions.UPDATE_ATTRIBUTE: {
      const copy = ObjectUtil.copy( state.data );
      const attrs = copy.attributes;
      for ( let n = 0; n < attrs.length; n++ ) {
        if ( attrs[n].id == action.attribute.id ) {
          attrs[n] = action.attribute;
          const tree = AttributeTree.attributesToTree( attrs );
          return { status : null, 
                   data : copy, 
                   attributeTree : tree,
                   currentTags : getTagsForAttributes( copy.attributes ) 
          };
        }
      }
      return state; // no change
    }

    case BlueprintActions.REMOVE_ATTRIBUTE: {

      const copy = ObjectUtil.copy( state.data );
      const attrs = copy.attributes;
      for ( let n = 0; n < attrs.length; n++ ) {
        if ( attrs[n].id == action.attribute.id ) {
          attrs.splice( n, 1 );
          const tree = AttributeTree.attributesToTree( attrs );
          return { status : null, 
                   data : copy, 
                   attributeTree : tree,
                   currentTags : getTagsForAttributes( copy.attributes )  
          };
        }
      }
      return state; // no change
    }

    case BlueprintActions.ADD_ATTRIBUTE_GROUP: {
      const tree = ObjectUtil.copy( state.attributeTree );
      AttributeTree.addGroupToTree( tree, action.path );

      return { status : state.status, 
               data : state.data, 
               attributeTree : tree, 
               currentTags : state.currentTags 
      };
    }

    case BlueprintActions.CHANGE_LOCAL_ATTRIBUTE_GROUP: {
      const tree = ObjectUtil.copy( state.attributeTree );
      const node = AttributeTree.findNodeById( tree, action.id )
      node.name = action.name
      node.path = action.path

      return { status : state.status, 
               data : state.data, 
               attributeTree : tree, 
               currentTags : state.currentTags 
      };
    }

    case BlueprintActions.REMOVE_ATTRIBUTE_GROUP: {
      let data = state.data;
      const tree = ObjectUtil.copy( state.attributeTree );
      const grp = AttributeTree.removeGroupFromTree( tree, action.path );
      if ( grp ) {

        const attrs = AttributeTree.getAllAttributes( grp );
        if ( attrs && attrs.length > 0 ) {
          const attrIds = attrs.map( ( e ) => { return e.attribute.id; } );
          data = ObjectUtil.copy( data );
          for ( let n = data.attributes.length - 1; n >= 0; n-- ) {
            if ( attrIds.indexOf( data.attributes[n].id ) >= 0 ) {
              data.attributes.splice( n, 1 );
            }
          }
        }
      }
      return { status : state.status, 
               data, 
               attributeTree : tree, 
               currentTags : state.currentTags 
      };
    }

    case BlueprintActions.ADD_ALERT: {

      const copy = ObjectUtil.copy( state.data );
      copy.alerts = copy.alerts || []
      copy.alerts.push( action.alert );
      return { status : null, 
               data : copy, 
               attributeTree : state.attributeTree,
               currentTags : state.currentTags  
      }
    }

    case BlueprintActions.UPDATE_ALERT: {
      const copy = ObjectUtil.copy( state.data );
      const alerts = copy.alerts;
      ArrayUtil.replace( copy.alerts, 'id', action.alert.id, action.alert )
      return { status : null,   
               data : copy, 
               attributeTree : state.attributeTree,
               currentTags : state.currentTags  
      };
    }

    case BlueprintActions.REMOVE_ALERT: {

      const copy = ObjectUtil.copy( state.data );
      ArrayUtil.remove( copy.alerts, 'id', action.alert.id )
      return { status : null, 
               data : copy, 
               attributeTree : state.attributeTree,
               currentTags : state.currentTags  
      }
    }

    default:
      return state

  }
}

// function getTagArray( attrs ) {
//   let tags = {}
//   for ( let n = 0; n < attrs.length; n++ ) {
//     const attr = attrs[n];
//     if ( attr.tags && attr.tags.length > 0 ) {
//       for ( let t = 0; t < attr.tags.length; t++ ) {
//         tags[attr.tags[t]] = true;
//       }
//     }
//   }
//   return Object.keys( tags );
// }

module.exports = project;
